import { render, staticRenderFns } from "./DashboardAffiliate.vue?vue&type=template&id=39615e70&scoped=true"
import script from "./DashboardAffiliate.vue?vue&type=script&lang=js"
export * from "./DashboardAffiliate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39615e70",
  null
  
)

export default component.exports